import { Category, Product } from '../interfaces/domain/menu';

export function findProductById(categories: Category[], id: string): Product | null {
  for (const cat of categories) {
    const found = cat.products?.find((p) => p.id === id) ?? null;
    if (found) return found;
    if (cat.subcategories?.length) {
      const fromSub = findProductById(cat.subcategories, id);
      if (fromSub) return fromSub;
    }
  }
  return null;
}

export function findCategoryByProductId(
  categories: Category[],
  productId: string
): Pick<Category, 'name' | 'description'> | null {
  for (const cat of categories) {
    if (cat.products?.some((p) => p.id === productId)) {
      return { name: cat.name, description: cat.description };
    }
    if (cat.subcategories?.length) {
      const fromSub = findCategoryByProductId(cat.subcategories, productId);
      if (fromSub) return fromSub;
    }
  }
  return null;
}
